import React, { useState, useEffect } from 'react';
import Accordion from 'react-bootstrap/Accordion';
import { collection, getDocs, updateDoc, doc, getDoc, setDoc, onSnapshot, query, where } from 'firebase/firestore';
import { Formik, Form as FormikForm, Field } from 'formik';
import { db } from '../firebaseConfig/firebase';
import { Row, Col, Container, Button, Form, Spinner, Badge, Card, Toast, ToastContainer } from 'react-bootstrap';

import Header from './Header';


// SUBCOMPONENTE: Formulario individual por alumno
const AlumnoForm = ({ alumno, onNotify }) => {

    const isMatch1 = alumno.TRIBUNAL === alumno.PRIORIDAD_1;
    const isMatch2 = alumno.TRIBUNAL === alumno.PRIORIDAD_2;
    const isMatch3 = alumno.TRIBUNAL === alumno.PRIORIDAD_3;

    const handleInputChange = (e, setFieldValue) => {
        const { name, value } = e.target;
        let cleanValue = value.replace(',', '.')
            .replace(/[^0-9.]/g, '')
            .replace(/(\..*?)\..*/g, '$1')
            .replace(/^(\d+\.\d{2}).*$/, '$1');

        if (parseFloat(cleanValue) > 10) cleanValue = "10";
        setFieldValue(name, cleanValue);
    };

    const handleSave = async (values) => {
        try {
            // Parseamos las 4 subnotas de la ENTREVISTA
            const nCapacidad = parseFloat(values.capacidadDefender.toString().replace(',', '.')) || 0;
            const nMotivacion = parseFloat(values.motivacionPersonal.toString().replace(',', '.')) || 0;
            const nEquipo = parseFloat(values.trabajoEquipo.toString().replace(',', '.')) || 0;
            const nResponsable = parseFloat(values.responsable.toString().replace(',', '.')) || 0;

            // Calculamos el promedio de la Entrevista
            const nEntrevista = (nCapacidad + nMotivacion + nEquipo + nResponsable) / 4;

            // Nota del expediente
            const nExp = parseFloat(values.notaExp.toString().replace(',', '.')) || 0;

            // Parseamos las 4 subnotas del PORTFOLIO
            const nCalidad = parseFloat(values.calidadTecnica.toString().replace(',', '.')) || 0;
            const nOriginalidad = parseFloat(values.originalidad.toString().replace(',', '.')) || 0;
            const nDiversidad = parseFloat(values.diversidad.toString().replace(',', '.')) || 0;
            const nReflexiva = parseFloat(values.capacidadReflexiva.toString().replace(',', '.')) || 0;

            // Calculamos el promedio del Portfolio
            const nPortfolio = (nCalidad + nOriginalidad + nDiversidad + nReflexiva) / 4;

            // Calculamos la media total del candidato
            const promedio = ((nEntrevista + nExp + nPortfolio) / 3).toFixed(2);

            const docRef = doc(db, "tribu-esp", alumno.id);

            // Guardamos todo en Firestore
            await updateDoc(docRef, {
                // Subnotas y nota final de la Entrevista
                CAPACIDAD_DEFENDER: values.capacidadDefender,
                MOTIVACION_PERSONAL: values.motivacionPersonal,
                TRABAJO_EQUIPO: values.trabajoEquipo,
                RESPONSABLE: values.responsable,
                NOTA_ENTREVISTA: nEntrevista.toFixed(2), // Guardamos el promedio calculado

                NOTA_EXP: values.notaExp,

                // Subnotas y nota final del Portfolio
                CALIDAD_TECNICA: values.calidadTecnica,
                ORIGINALIDAD: values.originalidad,
                DIVERSIDAD: values.diversidad,
                CAPACIDAD_REFLEXIVA: values.capacidadReflexiva,
                NOTA_PORTFOLIO: nPortfolio.toFixed(2),

                TOTAL_CANDIDATO: promedio
            });

            onNotify(`¡Guardado! Media: ${promedio}`, 'success');

        } catch (error) {
            onNotify('Error al guardar los datos.', 'danger');
        }
    };
    return (
        <>
            <Formik
                initialValues={{
                    // Nuevos campos de entrevista
                    capacidadDefender: alumno.CAPACIDAD_DEFENDER || '',
                    motivacionPersonal: alumno.MOTIVACION_PERSONAL || '',
                    trabajoEquipo: alumno.TRABAJO_EQUIPO || '',
                    responsable: alumno.RESPONSABLE || '',

                    notaExp: alumno.NOTA_EXP || '',

                    // Campos de portfolio
                    calidadTecnica: alumno.CALIDAD_TECNICA || '',
                    originalidad: alumno.ORIGINALIDAD || '',
                    diversidad: alumno.DIVERSIDAD || '',
                    capacidadReflexiva: alumno.CAPACIDAD_REFLEXIVA || ''
                }}
                onSubmit={handleSave}
                enableReinitialize={true}
            >
                {({ isSubmitting, dirty, values }) => {
                    const parseNota = (val) => {
                        if (val === undefined || val === null || val === '') return 0;
                        const strVal = val.toString().replace(',', '.');
                        return parseFloat(strVal) || 0;
                    };

                    // Cálculo en tiempo real de la ENTREVISTA
                    const nCapacidad = parseNota(values.capacidadDefender);
                    const nMotivacion = parseNota(values.motivacionPersonal);
                    const nEquipo = parseNota(values.trabajoEquipo);
                    const nResponsable = parseNota(values.responsable);
                    const tempEntrevista = (nCapacidad + nMotivacion + nEquipo + nResponsable) / 4;

                    // Nota Exp
                    const nExp = parseNota(alumno.NOTA_EXP);

                    // Cálculo en tiempo real del PORTFOLIO
                    const nCalidad = parseNota(values.calidadTecnica);
                    const nOriginalidad = parseNota(values.originalidad);
                    const nDiversidad = parseNota(values.diversidad);
                    const nReflexiva = parseNota(values.capacidadReflexiva);
                    const tempPortfolio = (nCalidad + nOriginalidad + nDiversidad + nReflexiva) / 4;

                    // Media Total
                    const tempMedia = (tempEntrevista + tempPortfolio + nExp) / 3;

                    return (
                        <FormikForm>
                            <div className="row">
                                <div className="col-md-7 border-end">
                                    <h5>Calificaciones</h5>

                                    <Row className="mb-2">

                                    </Row>

                                    {/* SECCIÓN ENTREVISTA DESGLOSADA */}
                                    <div className="p-2 border rounded bg-light mb-3 mt-3">
                                        <h6 className="small fw-bold text-secondary mb-2">Desglose Entrevista</h6>
                                        <Row className="mb-2">
                                            <Col>
                                                <Form.Group>
                                                    <Form.Label className="small mb-0">Capacidad defensa y argumentación</Form.Label>
                                                    <Field name="capacidadDefender">
                                                        {({ field, form }) => (
                                                            <Form.Control {...field} type="text" size="sm" placeholder="0.00" onChange={(e) => handleInputChange(e, form.setFieldValue)} />
                                                        )}
                                                    </Field>
                                                </Form.Group>
                                            </Col>
                                            <Col>
                                                <Form.Group>
                                                    <Form.Label className="small mb-0">Motivación personal</Form.Label>
                                                    <Field name="motivacionPersonal">
                                                        {({ field, form }) => (
                                                            <Form.Control {...field} type="text" size="sm" placeholder="0.00" onChange={(e) => handleInputChange(e, form.setFieldValue)} />
                                                        )}
                                                    </Field>
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                <Form.Group>
                                                    <Form.Label className="small mb-0">Trabajo en equipo</Form.Label>
                                                    <Field name="trabajoEquipo">
                                                        {({ field }) => (
                                                            <Form.Control
                                                                {...field}
                                                                type="text"
                                                                size="sm"
                                                                placeholder="0.00"
                                                                readOnly
                                                                className="bg-light text-muted" // Esto le da el aspecto visual "muteado"
                                                                style={{ cursor: 'not-allowed' }}
                                                            />
                                                        )}
                                                    </Field>
                                                </Form.Group>
                                            </Col>
                                            <Col>
                                                <Form.Group>
                                                    <Form.Label className="small mb-0">Responsabilidad, cuidado material y respeto normas </Form.Label>
                                                    <Field name="responsable">
                                                        {({ field }) => (
                                                            <Form.Control
                                                                {...field}
                                                                type="text"
                                                                size="sm"
                                                                placeholder="0.00"
                                                                readOnly
                                                                className="bg-light text-muted" // Esto le da el aspecto visual "muteado"
                                                                style={{ cursor: 'not-allowed' }}
                                                            />
                                                        )}
                                                    </Field>
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                    </div>

                                    {/* SECCIÓN PORTFOLIO DESGLOSADO */}
                                    <div className="p-2 border rounded bg-light mb-3">
                                        <h6 className="small fw-bold text-secondary mb-2">Desglose Portfolio</h6>
                                        <Row className="mb-2">
                                            <Col>
                                                <Form.Group>
                                                    <Form.Label className="small mb-0">Calidad técnica y narrativa</Form.Label>
                                                    <Field name="calidadTecnica">
                                                        {({ field, form }) => (
                                                            <Form.Control {...field} type="text" size="sm" placeholder="0.00" onChange={(e) => handleInputChange(e, form.setFieldValue)} />
                                                        )}
                                                    </Field>
                                                </Form.Group>
                                            </Col>
                                            <Col>
                                                <Form.Group>
                                                    <Form.Label className="small mb-0">Originalidad, sensibilidad artística</Form.Label>
                                                    <Field name="originalidad">
                                                        {({ field, form }) => (
                                                            <Form.Control {...field} type="text" size="sm" placeholder="0.00" onChange={(e) => handleInputChange(e, form.setFieldValue)} />
                                                        )}
                                                    </Field>
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                <Form.Group>
                                                    <Form.Label className="small mb-0">Diversidad y capacidad de adaptación</Form.Label>
                                                    <Field name="diversidad">
                                                        {({ field, form }) => (
                                                            <Form.Control {...field} type="text" size="sm" placeholder="0.00" onChange={(e) => handleInputChange(e, form.setFieldValue)} />
                                                        )}
                                                    </Field>
                                                </Form.Group>
                                            </Col>
                                            <Col>
                                                <Form.Group>
                                                    <Form.Label className="small mb-0">Capacidad reflexiva</Form.Label>
                                                    <Field name="capacidadReflexiva">
                                                        {({ field, form }) => (
                                                            <Form.Control {...field} type="text" size="sm" placeholder="0.00" onChange={(e) => handleInputChange(e, form.setFieldValue)} />
                                                        )}
                                                    </Field>
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                    </div>

                                    {/* RESUMEN DE MEDIAS */}
                                    <Row className="align-items-center mb-2 text-center text-sm">
                                        <Col>
                                            <div className="p-2 border rounded bg-white">
                                                <span className="d-block small text-muted">Media Entrevista</span>
                                                <span className="fw-bold text-info">{tempEntrevista.toFixed(2)}</span>
                                            </div>
                                        </Col>
                                        <Col>
                                            <div className="p-2 border rounded bg-white">
                                                <span className="d-block small text-muted">Media Portfolio</span>
                                                <span className="fw-bold text-info">{tempPortfolio.toFixed(2)}</span>
                                            </div>
                                        </Col>
                                        <Col>
                                            <div className="p-2 border rounded bg-white">
                                                <span className="d-block small text-muted">Nota Exp</span>
                                                <span className="fw-bold text-info">{alumno.NOTA_EXP || '0'}</span>
                                            </div>
                                        </Col>
                                    </Row>

                                    <Row className="align-items-center">
                                        <Col>
                                            <div className="p-2 bg-light border rounded text-center">
                                                <strong>Total Global: </strong>
                                                <span className="text-primary fs-5">{tempMedia.toFixed(2)}</span>
                                            </div>
                                        </Col>
                                    </Row>

                                    <Button
                                        type="submit"
                                        size="sm"
                                        variant="success"
                                        className="mt-3 w-100"
                                        disabled={!dirty || isSubmitting}
                                    >
                                        {isSubmitting ? 'Guardando...' : 'Guardar Calificaciones'}
                                    </Button>
                                </div>

                                <div className="col-md-5 border-start ps-4">
                                    {/* Cabecera con Badge Estilizado */}
                                    <div className="d-flex justify-content-between align-items-center mb-3">
                                        <h5 className="m-0 text-dark">Detalles del Alumno</h5>
                                        <span className={`badge rounded-pill px-3 py-2 ${alumno.FOUNDATION ? 'bg-success-subtle text-success border border-success' : 'bg-light text-muted border'}`}>
                                            <i className={`bi ${alumno.FOUNDATION ? 'bi-patch-check-fill' : 'bi-x-circle'} me-1`}></i>
                                            {alumno.FOUNDATION ? 'FOUNDATION' : 'NO FND'}
                                        </span>
                                    </div>

                                    {/* Sección de Contacto con Card */}
                                    <div className="bg-light rounded-3 p-3 mb-3 border-0 shadow-sm">
                                        <div className="d-flex align-items-center mb-3">
                                            <div className="icon-box bg-white rounded-circle p-2 shadow-sm me-3">
                                                <i className="bi bi-envelope-at-fill text-primary"></i>
                                            </div>
                                            <div className="text-truncate">
                                                <small className="text-muted d-block" style={{ fontSize: '0.7rem' }}>EMAIL DE CONTACTO</small>
                                                <span className="fw-medium">{alumno.EMAIL_ALUMNO}</span>
                                            </div>
                                        </div>

                                        <div className="d-flex gap-2">
                                            <a href={alumno.PORTFOLIO} target="_blank" rel="noreferrer" className="btn btn-outline-dark btn-sm w-100 rounded-2 shadow-sm ">
                                                <i className="bi bi-briefcase me-1"></i> Portfolio
                                            </a>
                                            {alumno.PORTFOLI_UPDATE && (
                                                <a href={alumno.PORTFOLI_UPDATE} target="_blank" rel="noreferrer" className="btn btn-outline-dark btn-sm w-100 rounded-2 shadow-sm">
                                                    <i className="bi bi-arrow-repeat me-1"></i> Update
                                                </a>
                                            )}
                                        </div>
                                    </div>

                                    {/* Sección de Prioridades Visuales */}
                                    <div className="pt-2">
                                        <h6 className="small fw-bold text-uppercase text-muted mb-3 tracking-wider">Orden de Prioridades</h6>
                                        <div className="d-flex flex-column gap-2">
                                            {/* Prioridad 1 */}
                                            <div className={`d-flex align-items-center border rounded-3 p-2 flex-grow-1 ${isMatch1 ? 'border-2 border-warning bg-warning-subtle' : 'bg-white'}`}>
                                                <span className="badge bg-secondary opacity-50 me-2">1º</span>
                                                <small className={`fw-medium ${isMatch1 ? 'text-dark fw-bold' : 'text-secondary'}`}>
                                                    {alumno.PRIORIDAD_1}
                                                </small>
                                                {isMatch3 && <i className="bi bi-check-circle-fill ms-auto text-warning"></i>}
                                            </div>
                                            {/* Prioridad 2 */}
                                            <div className={`d-flex align-items-center border rounded-3 p-2 flex-grow-1 ${isMatch2 ? 'border-2 border-warning bg-warning-subtle' : 'bg-white'}`}>
                                                <span className="badge bg-secondary opacity-50 me-2">2º</span>
                                                <small className={`fw-medium ${isMatch2 ? 'text-dark fw-bold' : 'text-secondary'}`}>
                                                    {alumno.PRIORIDAD_2}
                                                </small>
                                                {isMatch2 && <i className="bi bi-check-circle-fill ms-auto text-warning"></i>}
                                            </div>
                                            {/* Prioridad 3 */}
                                            <div className={`d-flex align-items-center border rounded-3 p-2 flex-grow-1 ${isMatch3 ? 'border-2 border-warning bg-warning-subtle' : 'bg-white'}`}>
                                                <span className="badge bg-secondary opacity-50 me-2">3º</span>
                                                <small className={`fw-medium ${isMatch3 ? 'text-dark fw-bold' : 'text-secondary'}`}>
                                                    {alumno.PRIORIDAD_3}
                                                </small>
                                                {isMatch3 && <i className="bi bi-check-circle-fill ms-auto text-warning"></i>}
                                            </div>

                                        </div>
                                    </div>
                                    
                                    {/* Sección de Comentarios */}
                                    {alumno.COMENTARIOS && (
                                        <div className="mt-4">
                                            <h6 className="small fw-bold text-uppercase text-muted mb-3 tracking-wider">Notas y Observaciones</h6>
                                            <div className="bg-light rounded-3 p-3 border-0 shadow-sm">
                                                <div className="d-flex">
                                                    <div>
                                                        <p className="small text-dark mb-0 lh-sm">
                                                            {alumno.COMENTARIOS}
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </FormikForm>
                    );
                }}
            </Formik>
        </>
    );
};


function Hometribu({ handleLogout, email }) {

    const [alumnos, setAlumnos] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");

    // ESTADO GLOBAL DE NOTIFICACIONES
    const [notification, setNotification] = useState({ show: false, msg: '', variant: 'success' });

    const notify = (msg, variant = 'success') => {
        setNotification({ show: true, msg, variant });
    };

    useEffect(() => {
        const q = query(collection(db, "tribu-esp"), where("EMAIL_Tribunal", "==", email));
        const unsubscribe = onSnapshot(q, (snapshot) => {
            setAlumnos(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
        });
        return () => unsubscribe();
    }, [email]);

    const alumnosFiltrados = alumnos.filter((a) =>
        a.ALUMNO?.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <>
            <Header />
            {/* CONTENEDOR ÚNICO DE TOASTS */}
            <ToastContainer position="top-end" className="p-3" style={{ zIndex: 9999, position: 'fixed' }}>
                <Toast
                    onClose={() => setNotification({ ...notification, show: false })}
                    show={notification.show}
                    delay={3000}
                    autohide
                    bg={notification.variant}
                >
                    <Toast.Body className="text-white fw-bold">{notification.msg}</Toast.Body>
                </Toast>
            </ToastContainer>
            <Container className="mt-4">
                <h2 className="text-2xl font-semibold tracking-tight text-slate-800 mb-4">
                    Evaluación especialidad
                </h2>
                {/* --- BARRA DE BÚSQUEDA --- */}
                <Card className="mb-4 border-0">
                    <Card.Body className="p-3">
                        <Form.Control
                            type="text"
                            placeholder="🔍 Buscar alumno por nombre..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            className="form-control-lg"
                        />
                    </Card.Body>
                </Card>
                <Accordion>
                    {alumnosFiltrados.length > 0 ? (
                        alumnosFiltrados.map((a, index) => (
                            <Card key={a.id} className="mb-2 shadow-sm">
                                <Accordion.Item eventKey={index.toString()}>
                                    <Accordion.Header>
                                        <div className="d-flex justify-content-between w-100 pe-3 align-items-center">
                                            <span><strong>{a.ALUMNO}</strong></span>
                                            <div><h5><Badge
                                                bg={parseFloat(a.TOTAL_CANDIDATO) >= 5 ? "success" : "danger"}
                                                className="px-3 py-2"
                                            >
                                                {a.TOTAL_CANDIDATO}
                                            </Badge></h5></div>
                                            <h5><Badge bg="warning" className="ms-2 border-2 text-dark">{a.TRIBUNAL}</Badge></h5>
                                        </div>
                                    </Accordion.Header>
                                    <Accordion.Body>
                                        <AlumnoForm alumno={a} onNotify={notify} />
                                    </Accordion.Body>
                                </Accordion.Item>
                            </Card>
                        ))
                    ) : (
                        <div className="text-center mt-5 text-muted">
                            <p>No se han encontrado alumnos que coincidan con "{searchTerm}"</p>
                        </div>
                    )}
                </Accordion>
            </Container>
        </>
    );
};

export default Hometribu